<template>
  <div class="epidemic-temperature-measurement-line">
    <div id="epidemicTemperatureMeasurement" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../../view/api/epidemicSituation'

  export default {
    name: 'epidemic-temperature-measurement',
    props: {
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '240px'
        }
      },
      buildingCode: {
        type: String,
        default () {
          return ''
        }
      }
    },
    data () {
      return {
        legendData: ['体温正常', '体温异常'],
        xData: [],
        yData1: [],
        yData2: []
      }
    },
    mounted () {
        this.tempratureCountList()
    },
    methods: {
      // 获取数据
      tempratureCountList () {
        this.$axios.post(api.tempratureCountList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let xData = []
              let yData1 = []
              let yData2 = []
              data.map(v => {
                xData.push(v.curDate)
                yData1.push(v.normalCount)
                yData2.push(v.abnormalCount)
              })
              this.xData = xData
              this.yData1 = yData1
              this.yData2 = yData2
              this.drawContractListGroupByFellower()
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      drawContractListGroupByFellower() {
          let _self = this
        let epidemicTemperatureMeasurement = this.$echarts.init(document.getElementById('epidemicTemperatureMeasurement'))
        epidemicTemperatureMeasurement.setOption({
          title: {
            text: '七日测温人数统计',
          },
          tooltip : {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
          },
          legend: {
            data: _self.legendData
          },
          // color: ['#92D050', '#FFC000'],
          grid: {
            left: '30px',
            right: '50px',
            bottom: '10px',
            containLabel: true
          },
          xAxis:  {
            type: 'category',
            name: '日期',
            data: _self.xData
          },
          yAxis: [
            {
              type: 'value',
              name: '人数',
              splitLine: {
                show: false
              },
            }
          ],
          series: [
            {
                name: '体温异常',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                    color: '#FFC000'
                },
                areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#FFC000'
                    }, {
                        offset: 1,
                        color: '#ffe'
                    }])
                },
                data: _self.yData2
            }, {
                name: '体温正常',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                    color: '#92D050'
                },
                areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#92D050'
                    }, {
                        offset: 1,
                        color: '#ffe'
                    }])
                },
                data: _self.yData1
            },
          ]
        })
      },
    },
    watch: {}
  }
</script>

<style scoped>
  .epidemic-temperature-measurement-line {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Line/EpidemicTemperatureMeasurement.vue